import {
    RiArrowDownSLine, RiArrowUpSLine,
} from "@remixicon/react";
import React, { useMemo, useState } from "react";
import { DueDateType } from "../../../../../__generated__/api";
import Button from "../../../../theme/button/Button";
import { TicketDueDatesRow } from "../../../labels/sla/Sla";
import Styles from "../TicketDetails.module.scss";
import {
    DetailSection,
    TicketProperties, sectionRegistry,
} from "./base";
import { LoggingHandler } from "../../../../../contexts/logging/LoggingContext";

export default function SLASection({
    ticket, isMinimized, onToggleExpand, metricPathPrefix,
}: TicketProperties) {
    ticket.useUpdates();

    const [isExpanded, setIsExpanded] = useState(false);

    const metricPath = useMemo(() => [...metricPathPrefix, "sla"], metricPathPrefix);

    return !ticket.ticket.dueDates?.isNotEmpty ? undefined : (
        <DetailSection
            title="SLAs"
            isMinimized={isMinimized}
            className="sla-section"
            onToggleExpand={onToggleExpand}
        >
            <div className={Styles["sla-container"]}>
                {ticket.ticket.dueDates.map(dueDate => (
                    <TicketDueDatesRow
                        key={dueDate.type + dueDate.dueDate}
                        ticketDueDate={dueDate}
                        isDueDateHistoryExpanded={isExpanded}
                        metricPathPrefix={metricPath}
                    />
                ))}

                <Button
                    variant="none"
                    size="small"
                    className={Styles["sla-show-more"]}
                    onClick={() => {
                        setIsExpanded(value => !value);
                        if (!isExpanded) {
                            LoggingHandler.instance.metric([...metricPath, "expand"]);
                        }
                    }}
                >
                    {isExpanded ? <RiArrowUpSLine /> : <RiArrowDownSLine />}
                    {isExpanded ? "Hide History" : "Show History"}
                </Button>
            </div>

        </DetailSection>

    );
}

sectionRegistry.register({
    sectionId: "urn:fq:portal-chat-section:sla",
    label: "SLAs",
    component: SLASection,
});
